/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export function toDateTimeLocalValue(value: string): string {
    if (value === 'NOW') {
        return '';
    }

    return value.replace(' ', 'T').slice(0, 16);
}

export function toApiDateTimeValue(value: string): string {
    return `${value.replace('T', ' ')}:00`;
}

export function formatImportedAt(
    value: string,
    locale = 'de-DE',
    unknownText = 'Unknown',
): string {
    if (!value) {
        return unknownText;
    }

    const parsedDate = new Date(value);

    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }

    return parsedDate.toLocaleString(locale);
}

/** Formats API KPI timestamps according to the selected application locale. */
export function formatKpiDateTime(value: string, locale: string): string {
    if (!value) {
        return value;
    }

    // API time-series values use a space between date and time. Parse that explicitly.
    const parsedDate = new Date(value.replace(' ', 'T'));

    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }

    return parsedDate.toLocaleString(locale);
}

export function formatUnixTimestampMs(
    value: string,
    locale = 'de-DE',
    unknownText = 'Unknown',
): string {
    if (!value) {
        return unknownText;
    }

    const timestamp = Number(value);

    if (!Number.isFinite(timestamp)) {
        return value;
    }

    const parsedDate = new Date(timestamp);

    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }

    return parsedDate.toLocaleString(locale);
}
